import React from 'react';
import { motion } from 'framer-motion';
import GlobeMap from '../../Common/GlobeMap/GlobeMap';
import './Globe.css';

const Globe: React.FC = () => {

  return (
    <motion.section 
      className='globe-section' 
      id='globe'
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className='container'>
        <div className='globe-map'>
          <GlobeMap lat={51.5074} lng={-0.1278} zoom={4} />
        </div>
      </div>
    </motion.section>
  );
};

export default Globe;
